var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24SupportDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 102,
    viewBox: "0 0 272 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.99 28.439C171.99 20.2852 165.275 13.5703 157.121 13.5703H115.393C107.239 13.5703 100.524 20.2852 100.524 28.439V57.2171C100.524 65.3709 107.239 72.0858 115.393 72.0858H160.366L166.234 78.3933C168.153 80.3119 171.99 78.8729 171.99 75.9951V28.439Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.732 37.1886C155.732 26.8493 147.199 18.7344 136.834 18.7344C126.469 18.7344 117.894 26.8493 116.894 37.1474C114.98 37.3121 113.439 38.9186 113.439 40.8959V47.4867C113.439 49.5463 115.146 51.2352 117.228 51.2352C117.352 51.2352 117.436 51.2352 117.561 51.2352C117.685 52.059 118.393 52.6769 119.267 52.6769C120.225 52.6769 121.016 51.8942 121.016 50.9468V47.4867V40.8959V37.1886C121.016 36.2411 120.225 35.4585 119.267 35.4585C119.101 35.4585 118.976 35.4997 118.851 35.4997C120.516 26.8905 127.926 20.3821 136.834 20.3821C145.825 20.3821 153.276 27.014 154.858 35.788C154.567 35.5821 154.234 35.4585 153.818 35.4585C152.86 35.4585 152.069 36.2411 152.069 37.1886V40.8959V47.4867V50.9468C152.069 51.6471 152.486 52.2238 153.068 52.5121C151.903 57.0433 149.197 60.9978 145.409 63.5105C145.034 63.0986 144.493 62.8102 143.869 62.8102H140.206C139.04 62.8102 138.124 63.7165 138.124 64.8698C138.124 66.0232 139.04 66.9295 140.206 66.9295H143.869C144.909 66.9295 145.784 66.1468 145.909 65.1582C150.404 62.3159 153.609 57.7024 154.775 52.3886C155.15 52.1414 155.441 51.7295 155.524 51.2352C155.608 51.2352 155.732 51.2352 155.857 51.2352C157.939 51.2352 159.645 49.5463 159.645 47.4867V40.8959C159.645 39.0422 159.146 37.4769 156.732 37.1886Z",
    fill: "#FF542E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.762 51.7736V50.4143L126.51 48.7666C130.673 44.8533 132.546 42.7525 132.588 40.3222C132.588 38.6745 131.797 37.1504 129.341 37.1504C127.842 37.1504 126.635 37.8918 125.886 38.5097L125.178 36.9856C126.302 36.0382 127.925 35.3379 129.799 35.3379C133.295 35.3379 134.794 37.727 134.794 40.0338C134.794 42.9997 132.629 45.43 129.174 48.6842L127.884 49.8788V49.92H135.21V51.7325H124.762V51.7736Z",
    fill: "#FF542E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.452 51.7724V47.3648H136.876V45.9231L144.161 35.625H146.533V45.6759H148.823V47.406H146.533V51.8136H144.452V51.7724ZM144.452 45.6348V40.2385C144.452 39.4147 144.494 38.5497 144.535 37.7258H144.452C143.953 38.6732 143.536 39.3735 143.078 40.115L139.082 45.5936V45.6348H144.452Z",
    fill: "#FF542E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43701 6.89266L15.6892 18.1449L21.4176 23.8732C22.472 24.9276 24.1873 24.9276 25.2574 23.8732L29.7425 19.3881L31.0016 18.1291L42.2696 6.87695H4.43701V6.89266Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5078 26.1071C27.5078 26.1228 27.4921 26.1228 27.5078 26.1071L26.7052 26.9097C25.7924 27.8224 24.5807 28.2946 23.3689 28.2946C22.1571 28.2946 20.9454 27.8382 20.0326 26.9097L19.23 26.1071L15.7206 22.5977L6.02637 32.2918H40.7272L31.033 22.5977L30.0573 23.5734L27.5078 26.1071Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.47 20.3791L4.40527 11.3145V29.4438L13.47 20.3791Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2363 20.3791L42.301 29.4438V11.3145L33.2363 20.3791Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.94 5.375H248.339C246.656 5.375 245.295 6.75203 245.295 8.45035V9.8273V15.9627H234.325C232.641 15.9627 231.28 17.3397 231.28 19.038V31.4771C231.28 33.1601 232.657 34.5524 234.325 34.5524H248.339L252.149 38.3928C252.302 38.5458 252.608 38.6988 252.914 38.6988C253.526 38.6988 253.985 38.2398 253.985 37.6277V24.1177H264.955C266.638 24.1177 268 22.7407 268 21.0423V8.45035C267.985 6.75203 266.623 5.375 264.94 5.375ZM250.925 33.0071L250.466 32.5481L249.548 31.4771H248.324H234.309V19.038H245.279V21.027V26.8564C245.279 27.7744 246.503 28.2334 247.1 27.6214L250.604 24.0871H250.91V33.0071H250.925Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.578 24.8672C238.119 24.8672 237.66 25.3262 237.66 25.7853C237.66 26.2443 238.119 26.7032 238.578 26.7032C239.037 26.7032 239.496 26.2443 239.496 25.7853C239.496 25.1732 239.19 24.8672 238.578 24.8672Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.776 24.8672C241.317 24.8672 240.858 25.3262 240.858 25.7853C240.858 26.2443 241.317 26.7032 241.776 26.7032C242.235 26.7032 242.694 26.2443 242.694 25.7853C242.694 25.1732 242.235 24.8672 241.776 24.8672Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5907 37.4886L63.2173 41.1152L54.032 50.3005L50.4054 46.674L59.5907 37.4886ZM65.9744 36.6117L64.3543 34.9916C63.7301 34.3674 62.712 34.3674 62.0877 34.9916L60.5345 36.5448L64.1611 40.1714L65.967 38.3655C66.4574 37.875 66.4574 37.0947 65.9744 36.6117ZM48.5104 51.772C48.4435 52.0692 48.711 52.3367 49.0083 52.2624L53.051 51.2815L49.4244 47.6549L48.5104 51.772Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 86.5239,
    y: 7.57031,
    width: 99.4657,
    height: 93.6966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0.405273,
    y: 0.582031,
    width: 271.595,
    height: 59.777,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24SupportDark);
export default __webpack_public_path__ + "static/media/24_support_dark.1ea937b12c2ada6070fab57aecb00e56.svg";
export { ForwardRef as ReactComponent };